
<template>
  <div name="units">
    <FilterBar @searchChanged="setSearchValue">
      <template v-slot:filter>
        <div>
          <Dropdown
            :options="yearDropdown"
            :selected="filteredYear"
            :title="'Year Group'"
            v-on:updateOption="setYearValue"
            style="min-width: 12rem"
          ></Dropdown>
        </div>
        <dropdown
            :options="catDropdown"
            :selected="filteredCat"
            :title="'Unit Category'"
            v-on:updateOption="setCatValue"
            style="min-width: 15rem"
          >
            "></dropdown
          >
      </template>
      <template v-slot:actions>
        <div v-if="!showOverAccess">
          <button
            type="button"
            class="action-button hover:opacity-75"
            @click="addNew()"
          >
            <i class="fas fa-plus"></i>
            Add New
          </button>
        </div>
      </template>
    </FilterBar>

      <p v-if="showMessage" class="save-notice">
        {{ msg }} <i class="far fa-check-circle"></i>
      </p>

    <div
      v-if="showOverAccess && !this.currentUser.isContentAdmin"
      class="
        w-8/12
        mx-auto
        text-center
        my-10
        bg-white
        p-6
        rounded
        border border-red-300 border-opacity-50
      "
    >
      <h4 class="font-bold text-xl text-red-500">
        <i class="fas fa-exclamation-triangle pr-1 text-lg"></i> All 12 FREE
        library units used.
      </h4>

      <p class="p-4">
        If you wish to discuss your current access including full custom
        curriculum entries please contact us.
      </p>
      <p>
        <strong>
          Email:
          <a href="mailto:support@primarypepassport.co.uk" class="opacity-75"
            >support@primarypepassport.co.uk</a
          >
          or Telephone: <span class="opacity-75">0800 055 6550</span>
        </strong>
      </p>
    </div>

    <table
      class="
        w-95p
        mx-auto
        mb-2
        h-10
        pt-2
        align-text-bottom
        bg-white
        rounded
        text-left text-gray-400
      "
    >

    <thead class="bg-gray-100 w-full">
        <tr>
          <th v-for="(col, index) in columns" :key="index" class="pl-2" v-bind:class="col.css" @click="sort(col.shortcode)">
            {{col.label}} 
            <i v-if="col.shortcode.length > 0" class="fas fa-sort tbh-sort " v-bind:class="col.shortcode === sortBy ? 'text-blue-500' : 'text-gray-400'" ></i>
          </th>
          <th class="w-1/12" v-if="hasAccess"></th>
          <th class="w-1/12"></th>     
        </tr>
      </thead>
    </table>

    <div v-if="errored" class="empty">
      <p>
        We are not able to retrieve this information at the moment, please try
        back later
      </p>
    </div>

    <div id="content-area" v-else>
      <div
        style="width: 100%; text-align: center"
        class="spin-holder mt-4"
        v-if="loading"
      >
        <i class="spinner fa fa-spinner fa-spin"></i>
        <p>Loading Units</p>
      </div>

      <div v-else>
        <table
          v-if="componentLoaded"
          class="table-wrapper w-95p bg-white mx-auto rounded shadow-sm"
        >
          <tbody>
            <tr class="course" v-for="item in filteredList" :key="item.id">
              <td class="w-2/12">
                 <div class="pl-2" v-for="year in years" :key="year.id" v-if="year.id == item.year_id">
                  {{ year.name }}
                </div>
              </td>
              <td class="w-4/12">
                <strong>{{ item.name }}</strong>
              </td>
              <td class="w-3/12">
                  {{ item.category.name }}
        
              </td>
              <td align="center" class="w-2/12">
                <i
                  class="icon list"
                  v-bind:class="setActiveClass(item.active)"
                />
              </td>
              <td class="w-1/12 tb-actions" align="center" v-if="hasAccess" >
                <a v-on:click="showOutcomeModal(item)" class="text-button blue-text hover:opacity-50"
                  >Outcomes</a
                >
                
              </td>

              <td class="w-1/12 tb-actions" align="center" >
                <a v-on:click="showModal(item)" class="text-button orange-text hover:opacity-50"
                  >Edit</a
                >
                
              </td>
            </tr>
          </tbody>
          <tfoot></tfoot>
        </table>

        <p class="ml-10 mt-6 text-sm" v-else>
          We could not find any data for your given selection.
        </p>

        <ModalSlide
        :show="showOutcomes"
        :cssWidth="'md:w-6/12'"
        @closeModal="showOutcomes = false"
      >
        <template v-slot:header-icon>
          <i class="fas fa-edit"></i>
        </template>
        <template v-slot:header-title>
          {{selectedCourse.name}} outcomes
          <div class="text-xs">Add or remove outcomes to display within the unit</div>
        </template>
        <template v-slot:body>
          <Outcomeapply
          @refresh="refreshList"
          :subject="subject"
          :course="selectedCourse"
          :years="years"
          ref="outcomeApply"
          v-if="showOutcomes"
        ></Outcomeapply>
        </template>
      </ModalSlide>



  


      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
const ModalSlide = () => import("@/components/ModalSlide.vue");

const Dropdown = () => import("@/components/Dropdown.vue");
const FilterBar = () => import("@/components/FilterBarNavigation.vue");
const noaccess = () => import("@/components/NoAccess.vue");
const Outcomeapply = () => import("@/components/customunit/OutcomeApply.vue");
import { SchoolService, BaseService } from "@/services/school.service";
import { yearGroupMixin} from "@/mixins/yearGroupMixin.js";

export default {
  name: "units",
  mixins: [yearGroupMixin],
  props: {
    subject:  { type: Object, required: false },
  },
  computed: {
    ...mapGetters({
      currentUser: "currentUser",
      currentAccess: "currentAccess",
      settings: "settings",

    }),
    componentLoaded() {
      return this.orderedUnits.length > 0;
    },
    hasAccess() {
      return this.currentAccess.outcomeAccess || this.currentUser.isOrganisation ||  this.currentUser.isContentAdmin
    },
    yearDropdown() {
      var results = [{ id: 0, name: "All" }].concat(
        this.years
      );
      this.filteredYear = results[0];
      return results;
    },
    catDropdown() {
      var results = [{ id: 0, name: "All" }].concat(
        this.cats
      );
      this.filteredCat = results[0];
      return results;
    },
    overAccess() {
      return this.units.length >= 12 && !this.currentAccess.unitAccess;
    },
    orderedUnits() {
      var vm = this;
      var category = vm.filteredCat;
      let year = vm.filteredYear;

      if (year.id == 0 && category.id == 0) {
        return this.units
      } else {
        return vm.units.filter(function (unit) {
          let filtered = true;

          if (year.id > 0) {
            filtered = unit.year_id === year.id;
          }

          if (filtered) {
            if (category.id > 0) {
              filtered = unit.category.id === category.id;
            }
          }
          return filtered;
        });
      }
    },
    filteredList() {
      let vm = this
      var results = this.orderedUnits.filter((item) => {
       return item.name.toLowerCase().includes(vm.search.toLowerCase());
      });
      return _.orderBy(results, [vm.sortBy], [vm.sortDirection]);
    },
    isContentAdmin() {
      return this.currentUser.isContentAdmin;
    },
  },
  data() {
    return {
      loading: true,
      errored: false,
      showOverAccess: false,
      showFilter: false,
      showOutcomes: false,
      showMessage: false,
      units: [],
      cats: [],

      selectedCourse: {},
      filteredYear: {},
      filteredCat: {},
      search: "",

      sortBy: 'year_id',
      sortDirection: 'asc',

      columns: [
                { label: 'Year Group', shortcode: 'year_id', css: 'w-2/12' },
                { label: 'Unit Title', shortcode: 'name', css: 'w-4/12 text-left' },
                { label: 'Category', shortcode: 'category.name', css: 'w-3/12' },
                { label: 'Active', shortcode: 'active', css: 'w-1/12 text-left' },
            ], // columns
    };
  },
  created() {
    this.loading = true;

    // cats
    BaseService.getAll("categories")
      .then((response) => this.buildCategoryList(response.data.data))
      .catch((res) => {
        console.log(res);
      });
    this.fetchData();
  },
  mounted() {

  },
  watch: {
    '$props':{
      handler: function (val, oldVal) { 
        this.fetchData()
      },
      deep: true
    }
  },
  methods: {
    fetchData() {
      SchoolService.getAll("courses/subject/" + this.subject.id +"?visibility=private&state=all")
        .then((response) => this.buildUnitList(response.data.data))
        .catch((err) => {
          console.log("Courses " + err);
          this.errored = true;
        })
        .finally(() => (this.loading = false));
    },
    buildUnitList(data) {
      this.units = data;
      if (this.isContentAdmin) {
        this.showOverAccess = false
      } else {
        this.showOverAccess = this.units.length >= 12 && !this.currentAccess.unitAccess;
      }
    },
    buildCategoryList(data) {
      this.cats = data;
    },
    refreshUnits() {
      this.fetchData();
    },
    sort(s) {
      if (s === this.sortBy) {
        this.sortDirection = this.sortDirection === "asc" ? "desc" : "asc";
      }
      this.sortBy = s;
    },
    showModal(unit) {
      this.$store.commit("setUnit", unit);
      this.$router.push({
        name: "CustomUnit",
        params: { cats: this.cats, subject: this.subject },
      });
      window.scrollTo(0, 0);
    },
    addNew() {
      this.$store.commit("setUnit", {});
      this.$router.push({
        name: "CustomUnit",
        params: { cats: this.cats, subject: this.subject},

      });
    },
    showOutcomeModal(unit) {
      this.selectedCourse = unit
      this.showOutcomes = true
    },
    setCatValue(cat) {
      this.filteredCat = cat;
    },
    showCommunity() {
      this.$router.push({ path: "community" });
    },
    setFilter() {
      this.showFilter = !this.showFilter;
      if (this.showFilter == false) {
        this.filteredYears = [];
      }
    },
    setSearch() {
      this.showSearch = !this.showSearch;
      this.search = "";
    },
    setYearValue(value) {
      this.filteredYear = value
    },
    setSearchValue(value) {
      this.search = value;
    },
    setActiveClass(active) {
      if (active == 1) {
        return "fas fa-check-circle true";
      } else {
        return "fas fa-times-circle false";
      }
    },
    refreshList() {
      this.loading = true
      this.fetchData()
      this.showOutcomes = false;
    },
  },
  components: {
    Dropdown,
    FilterBar,
    noaccess,
    Outcomeapply,
    ModalSlide
  },
};
</script>


<style scoped>
.trash {
  cursor: pointer;
}
</style>
